import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContactingTestId, useIsIntersecting } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { BookVisitButton, MailButton, PhoneButtonContainer } from "../Buttons";
import { Box, useBreakpointValue } from "@gemini/core";
import { usePlatoAvailable } from "@/contexts/contact";
export const StickyCta = ({ tracking, variant = "light", position = "fixed", }) => {
    const { t } = useI18n();
    const dataTestId = useContactingTestId("StickyCta");
    const { avZone } = tracking;
    const isPlatoAvailable = usePlatoAvailable();
    const isMobile = useBreakpointValue({
        base: true,
        lg: false,
    });
    const { isIntersecting: isHardfactsBtnInView } = useIsIntersecting({
        elementId: "hardfacts-contact-buttons",
        triggerOnce: false,
        rootMargin: "0px",
        defaultState: isMobile,
    });
    return (_jsxs(Box, { display: {
            "breakpoint.base": !isHardfactsBtnInView ? "flex" : "none",
            "breakpoint.lg": "none",
        }, gap: "spacing.16", position: "fixed", bottom: "0", left: "0", right: "0", backgroundColor: variant === "light"
            ? "color.surface.default.default"
            : "color.background.constant.black", paddingVertical: "spacing.12", paddingHorizontal: {
            "breakpoint.base": "spacing.16",
            "breakpoint.sm": "spacing.32",
        }, borderTopStyle: "solid", borderTopWidth: variant === "light" ? "borderWidth.1" : "borderWidth.none", borderTopColor: "color.border.light.default", boxShadow: "shadow.8", zIndex: "zIndex.1", testId: dataTestId, unsafe_className: "HideOnPrint", visibility: isHardfactsBtnInView && position === "onScroll" ? "hidden" : "visible", children: [_jsx(PhoneButtonContainer, { tracking: { avZone, legacy: "detail-responsive" }, iconOnly: isPlatoAvailable }), isPlatoAvailable && (_jsx(BookVisitButton, { av_zone: avZone, rootTestId: dataTestId, variant: variant === "light" ? "secondary" : "secondary-inverted", children: t("contact.cta.book_visit") })), _jsx(MailButton, { rootTestId: dataTestId, av_zone: avZone, legacyTrackingInfos: "detail-responsive" })] }));
};
